import { useMemo } from "react";

export const useSelected = (
  selectedBurnIndexes: boolean[] | undefined
): {
  everySelected: boolean;
  someSelected: boolean;
  selectionCount: number;
  noneSelected: boolean;
} => {
  const everySelected = useMemo(
    () =>
      (selectedBurnIndexes?.length ?? 0) > 0 &&
      (selectedBurnIndexes?.every((it) => it) ?? false),
    [selectedBurnIndexes]
  );
  const someSelected = useMemo(
    () => !everySelected && (selectedBurnIndexes?.some((it) => it) ?? false),
    [everySelected, selectedBurnIndexes]
  );
  const selectionCount =
    selectedBurnIndexes?.reduce((a, b) => a + (b ? 1 : 0), 0) ?? 0;

  const noneSelected = !(someSelected || everySelected);
  return { everySelected, someSelected, selectionCount, noneSelected };
};
